// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__I1UYJ","ModalHeader":"Modal_ModalHeader__Ef+KV","Title":"Modal_Title__WhVzv","ModalBody":"Modal_ModalBody__Qq9ZR","CloseBtn":"Modal_CloseBtn__YhV4q"};